'use client';

import type { LocationRadiusSelectHandle } from '#/components/LocationRadiusSelect/LocationRadiusSelect';
import { useSearchRadius } from '#/modules/search/contexts/SearchContext';
import { useSearchRadiusOptions } from '#/modules/search/hooks/facets/useSearchRadiusOptions';
import { useSearchPageActions } from '#/modules/search/hooks/useSearchPageActions';
import type { SearchFromPageType } from '#/modules/search/types/SearchFromPageType';
import type { SearchType } from '#/modules/search/types/SearchType';

import { MobileSearchV2 } from './MobileSearchV2/MobileSearchV2';
import { useIsMobileSearchV2Enabled } from './MobileSearchV2/useIsMobileSearchV2Enabled';
import { useLayoutHeaderSearch } from './useLayoutHeaderSearch';

type Props = {
  defaultSearchType: SearchType;
  searchFromPageType: SearchFromPageType | undefined;
  isSearchLandingPage: boolean;
  isSearchPage: boolean;
};

export function LayoutHeaderMobileSearchIcon({
  defaultSearchType,
  searchFromPageType,
  isSearchLandingPage,
  isSearchPage,
}: Props) {
  const {
    initialQuery,
    searchLocation,
    changeSearchLocation,
    search,
    searchOnClear,
  } = useLayoutHeaderSearch({
    defaultSearchType,
    isSearchPage,
    isSearchLandingPage,
    embedSearchWidgetId: null,
    searchFromPageType,
  });

  const radius = useSearchRadius();
  const { setSearchUrlRadius } = useSearchPageActions({
    isSearchLandingPage,
  });

  const radiusOptions = useSearchRadiusOptions();

  const radiusHandle: LocationRadiusSelectHandle = isSearchPage
    ? { type: 'controlled', onChange: setSearchUrlRadius, radius }
    : { type: 'uncontrolled', radius };

  const isNewMobileSearch = useIsMobileSearchV2Enabled();

  if (!isNewMobileSearch) return null;

  return (
    <MobileSearchV2
      trigger="icon"
      defaultSearchType={defaultSearchType}
      isSearchPage={isSearchPage}
      isSearchLandingPage={isSearchLandingPage}
      initialQuery={initialQuery}
      searchLocation={searchLocation}
      onChangeSearchLocation={changeSearchLocation}
      radiusOptions={radiusOptions}
      radiusHandle={radiusHandle}
      onSearch={search}
      searchOnClear={searchOnClear}
    />
  );
}
